import { ErrorBoundary } from "react-error-boundary";
import { widgets } from "@widgets/widgets";
import Divider from '@widgets/elementorDefault/divider/divider';
import Spacer from '@widgets/elementorDefault/spacer/Spacer';
import ElementorImage from '@widgets/elementorDefault/image/elementor-image';
import React from "react";
import HtmlParser from "html-react-parser";
import { SlideShow } from '../slideshow';
function hiddenClassList(settings) {
    return ['hide_desktop', 'hide_tablet', 'hide_mobile'].reduce((agr, breakpoint) => settings[breakpoint] ? `${agr} elementor-${settings[breakpoint]}` : agr, ' ');
}
export function Section(props) {
    const { settings, elements, id, children, elType, widgetType } = props;
    // i template gali ateit be row/col
    if (elType == 'widget')
        return React.createElement(WidgetWrap, { id: id, settings: settings, widgetType: widgetType },
            React.createElement(Widget, Object.assign({}, props)));
    return React.createElement("section", { className: `elementor-section elementor-section-${(settings === null || settings === void 0 ? void 0 : settings.layout) === 'full_width' ? 'full_width' : 'boxed'} elementor-element elementor-element-${id}${hiddenClassList(settings)}`, key: id },
        (settings === null || settings === void 0 ? void 0 : settings.background_background) === 'slideshow' && (React.createElement(SlideShow, { images: (settings === null || settings === void 0 ? void 0 : settings.background_slideshow_gallery) || [] })),
        React.createElement("div", { className: `elementor-container elementor-column-gap-${(settings === null || settings === void 0 ? void 0 : settings.gap) ? settings.gap : 'default'}` }, elements === null || elements === void 0 ? void 0 : elements.map((col) => {
            return React.createElement(Column, Object.assign({ key: col.id }, col), children);
        })));
}
function Column({ settings, elements, id, children }) {
    return React.createElement("div", { className: `elementor-column elementor-col-${(settings === null || settings === void 0 ? void 0 : settings._column_size) || 100} elementor-element elementor-element-${id}${hiddenClassList(settings)}`, key: id },
        React.createElement("div", { className: `elementor-widget-wrap${(elements === null || elements === void 0 ? void 0 : elements.length) > 0 ? ' elementor-element-populated' : ''}` }, elements === null || elements === void 0 ? void 0 : elements.map((el) => React.createElement(WidgetWrap, { key: el.id, id: el.id, settings: el.settings, widgetType: el.widgetType },
            React.createElement(Widget, Object.assign({}, el), children)))));
}
function Widget(props) {
    const { elType, settings, children, id, widgetType } = props;
    const elData = JSON.stringify({ elType, settings, id, widgetType }, undefined, 2);
    if (elType === 'section') {
        return React.createElement(Section, Object.assign({}, props));
    }
    if (widgetType === 'divider') {
        return (React.createElement(Divider, Object.assign({}, props.settings, { _id: id })));
    }
    if (widgetType === 'spacer') {
        return (React.createElement(Spacer, Object.assign({}, props.settings, { _id: id })));
    }
    if (widgetType === 'image') {
        return (React.createElement(ElementorImage, Object.assign({}, props.settings)));
    }
    if (widgetType === 'theme-post-content') {
        return React.createElement(React.Fragment, null, children);
    }
    if (widgetType === 'text-editor') {
        return (React.createElement(React.Fragment, null, (settings === null || settings === void 0 ? void 0 : settings.editor) ? HtmlParser(settings === null || settings === void 0 ? void 0 : settings.editor) : ''));
    }
    const Element = !!widgets[widgetType] ? widgets[widgetType] : null;
    if (Element === null)
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", null, widgetType),
            React.createElement("pre", null, elData)));
    return React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback }, Element && React.createElement(Element, Object.assign({}, settings, { _id: id })));
}
const WidgetWrap = ({ widgetType, id, settings, children }) => {
    return (React.createElement("div", { className: `elementor-element elementor-element-${id}${hiddenClassList(settings)} elementor-widget elementor-widget-${widgetType}`, key: id },
        React.createElement("div", { className: "elementor-widget-container" }, children)));
};
function ErrorFallback({ error }) {
    return null;
}
